import { calcularTranchesDeEstadia as calcularTranchesNova } from "./utils/financeHelpers";
import PropertiesTab from "./components/PropertiesTab";
import SyncTab from "./components/SyncTab";
import CalendarTab from "./components/CalendarTab";
import DashboardTab from "./components/DashboardTab";
import RefundsTab from "./components/RefundsTab";
import AddStayTab from "./components/AddStayTab";
import ReceiptsTab from "./components/ReceiptsTab";
import React, { useState, useEffect } from "react";
import {
  LayoutDashboard,
  Users,
  PlusCircle,
  Euro,
  Calendar,
  TrendingUp,
  Home,
  Settings,
  Download,
  Upload,
  RefreshCw,
  CheckCircle2,
  AlertTriangle,
  Clock,
  Trash2,
  FileSpreadsheet,
  Building,
  ArrowRightLeft,
  Search,
  SlidersHorizontal,
  ChevronRight,
  Sparkles,
  Info,
  CreditCard,
  Coins,
  Check,
  AlertCircle,
  FileText,
  CalendarDays,
  ArrowUpRight,
  UserCheck,
  Filter,
  CheckSquare,
  Database,
  Lock,
  Mail,
  Phone,
  Globe,
  Briefcase,
  GraduationCap,
  Gift,
  Percent,
  CalendarClock,
} from "lucide-react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

// Importações padrão do Firebase SDK via NPM
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";

// ==========================================
// CONFIGURAÇÃO AUTOMÁTICA E DIRETA DO FIREBASE
// ==========================================
const firebaseConfig = {
  apiKey: "AIzaSyBU7nP7AcFDtc2PzXDqmxb22_jsiGGXof0",
  authDomain: "coolivin-controlo-rendas.firebaseapp.com",
  projectId: "coolivin-controlo-rendas",
  storageBucket: "coolivin-controlo-rendas.firebasestorage.app",
  messagingSenderId: "469298782930",
  appId: "1:469298782930:web:27b6d02f5b0e122747030b",
};

const APP_ID_FIXO = "coolivin-controlo-rendas";

// ==========================================
// CONSTANTES E CORES GLOBAIS
// ==========================================
const PROPRIEDADES = [
  "Carcavelos 1#",
  "Saldanha 3#",
  "Saldanha 4#",
  "Saldanha 5#",
  "Principe Real 6#",
  "Marques de Pombal 7#",
  "Telheiras 8#",
  "Saldanha 9#",
  "Saldanha 10#",
  "Principe Real 11#",
  "Principe Real 12#",
];
const LINKS_DESPESAS_PROPRIEDADES = {
  "Carcavelos 1#":
    "https://docs.google.com/spreadsheets/d/12DKjkO7u2n_JBUvCYK-XhdRHWZl3qIzh/edit?usp=drive_link&ouid=111087229369787546922&rtpof=true&sd=true",
  "Saldanha 3#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSyV9iNhTWPr7Kf6MZ1fh7j9_S87OKHnB-twZY7eLL7zKJpjwBqCOIR6n69j0cckw/pubhtml",
  "Saldanha 4#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vT0ofaFJsXpHZkSGhn4QxwxFeLB0xooUILKuNaUGM53Gw9XWA13_3GqkOf3Jx2kqQ/pubhtml",
  "Saldanha 5#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSz3FgWyDlP7EVhWFyjBFv7zFGFCyvhgIYpYdUkbFvX2zaE4i12dTXV8GVbane9iw/pubhtml",
  "Principe Real 6#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQogJYREA8o9LL0w3UlgBO2SzYfRKzLcWSI0Hg0mMuuACho2CjbMHafMNyX9fZuNQ/pubhtml",
  "Marques de Pombal 7#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vRmbAnTg8RydPt0MlR-TL5QhjL0Io3ZTusjPQWb4Qjx1kCwXH_lV9JSTvRH-C8Khw/pubhtml",
  "Telheiras 8#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSQ0ln5Ufz4uyzdkb_JkIp4hHY0ySbRXYm324nXUkSG8cJ_D7WqXlmA8llsrcKp22o_zlKRHQ60QTvN/pubhtml",
  "Saldanha 9#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vRASxWt4oY7So7SjvCgUlBEhgwd2nqCgsJ6GBRyrqyU0TLjZfqmrYSqkOSz19F7xQ/pubhtml",
  "Saldanha 10#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQqgRIAgO6fy5YH8GiYvL1rCuRgHVpq9PUlj2WE3QkkUqHH9S0ZJx-l0okSAyQbNw/pubhtml",
  "Principe Real 11#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vTMQrz0qmVrdOzR5ukQhE76H0nIRDbbPCsI95y5_OwaGIwgWpCrY3GJ_kj3EvipfA/pubhtml",
  "Principe Real 12#":
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSYnEobh56hx46gAIDTcajPuARip2mB-Fe2kohML00GaN1SRERmQSMFVwodfhcd2Q/pubhtml",
};
const GRAPH_COLORS = [
  "#0f172a",
  "#4f46e5",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
  "#14b8a6",
  "#f43f5e",
  "#64748b",
];

const DEMO_STAYS = [
  {
    id: 1001,
    propriedade: "Saldanha 3#",
    quarto: "Quarto 4",
    inquilino: "Camila Miguel",
    renda: 750,
    caucao: 650,
    adminFee: 150,
    despesasComuns: 45,
    dataReserva: "2026-02-15",
    checkIn: "2026-05-31",
    checkOut: "2026-08-31",
    checkInComunicado: "2026-06-05",
    checkOutComunicado: "",
    email: "camilam.miguel4@gmail.com",
    telemovel: "+551197308 6011",
    nacionalidade: "Brasil",
    ocupacao: "Estudante",
    universidade: "Estudante (UE)",
    idade: "25",
    ofertaEspecial: "Não",
    codigoOferta: "",
    origemCoolivin: "Não",
    plataformaOrigem: "Uniplaces",
    comissaoValor: "85",
    status: "Ativo",
    notas:
      "Reserva via Uniplaces. Desconto de 45€ e comissão de 85€ retidos na reserva e compensados no check-in.",
  },
  {
    id: 1002,
    propriedade: "Saldanha 4#",
    quarto: "Quarto Suite",
    inquilino: "Beatriz Reis",
    renda: 490,
    caucao: 490,
    adminFee: 0,
    despesasComuns: 45,
    dataReserva: "2026-04-10",
    checkIn: "2026-05-01",
    checkOut: "2026-10-31",
    checkInComunicado: "2026-05-01",
    checkOutComunicado: "2026-10-30",
    email: "beatriz.reis@ist.utl.pt",
    telemovel: "+351 912 345 678",
    nacionalidade: "Portuguesa",
    ocupacao: "Estudante",
    universidade: "IST",
    idade: "21",
    ofertaEspecial: "Não",
    codigoOferta: "",
    origemCoolivin: "Sim",
    plataformaOrigem: "",
    comissaoValor: "",
    status: "Ativo",
    notas: "Reserva direta Coolivin. Sem comissão.",
  },
];

// ==========================================
// FUNÇÕES UTILITÁRIAS DE SUPORTE
// ==========================================

const parseDateAgnostic = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return new Date();
  const parts = dateStr.split("-");
  if (parts.length !== 3) return new Date(dateStr);
  return new Date(
    parseInt(parts[0], 10),
    parseInt(parts[1], 10) - 1,
    parseInt(parts[2], 10)
  );
};

const formatYearMonthStr = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

const formatDateToPt = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string" || !dateStr.includes("-"))
    return dateStr || "-";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  if (parts[0].length === 2 && parts[2].length === 4) return dateStr;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

const formatMonthPt = (yearMonth) => {
  if (!yearMonth || !yearMonth.includes("-")) return yearMonth;
  const [year, month] = yearMonth.split("-");
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const idx = parseInt(month, 10) - 1;
  return `${months[idx]} ${year}`;
};

const formatMoneyValue = (val) => {
  const parsed = parseFloat(val);
  return isNaN(parsed) ? 0 : Math.round(parsed * 100) / 100;
};

const calcularTranchesDeEstadia = (stay) => {
  const tranches = [];
  const start = parseDateAgnostic(stay.checkIn);
  const end = parseDateAgnostic(stay.checkOut);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return [];

  const diaCheckIn = start.getDate();
  const diaCheckOut = end.getDate();

  const isFirstMonthHalf = diaCheckIn >= 16;
  const isLastMonthHalf = diaCheckOut <= 15;

  const listagemMeses = [];
  let tempDate = new Date(start.getFullYear(), start.getMonth(), 1);
  const lastDate = new Date(end.getFullYear(), end.getMonth(), 1);

  while (tempDate <= lastDate) {
    listagemMeses.push(new Date(tempDate));
    tempDate.setMonth(tempDate.getMonth() + 1);
  }

  if (listagemMeses.length === 0) return [];

  const lastIdx = listagemMeses.length - 1;

  const monthsConfig = listagemMeses.map((date, idx) => {
    const mesStr = formatYearMonthStr(date);
    return {
      idx,
      date,
      str: mesStr,
      value: formatMoneyValue(stay.renda),
      isHalf: false,
      justification: "",
      allocatedTo: "Mensalidade",
      isPlatformGap: false,
      isPlatformGapRecovered: false,
    };
  });

  if (isFirstMonthHalf) {
    monthsConfig[0].value = formatMoneyValue(stay.renda / 2);
    monthsConfig[0].isHalf = true;
    monthsConfig[0].justification =
      "Meia renda proporcional de entrada (Check-in dia " + diaCheckIn + ")";
    monthsConfig[0].allocatedTo = "CheckIn-MeiaRenda";

    if (monthsConfig.length > 1) {
      monthsConfig[1].allocatedTo = "Reserva";
    }
  } else {
    monthsConfig[0].allocatedTo = "Reserva";
  }

  if (listagemMeses.length > 1) {
    monthsConfig[lastIdx].allocatedTo = "CheckIn-UltimoMes";

    if (isLastMonthHalf) {
      const penultimateIdx = lastIdx - 1;
      monthsConfig[penultimateIdx].value = formatMoneyValue(
        monthsConfig[penultimateIdx].value - stay.renda / 2
      );
      monthsConfig[penultimateIdx].isHalf = true;
      monthsConfig[penultimateIdx].justification =
        "Ajuste de quinzena antecipado (Check-out dia " +
        diaCheckOut +
        " de " +
        formatMonthPt(monthsConfig[lastIdx].str) +
        ")";
    }
  }

  const isPlatformBooking = stay.origemCoolivin === "Não";
  const valorComissao = isPlatformBooking
    ? parseFloat(stay.comissaoValor) || 0
    : 0;
  const dc = parseFloat(stay.despesasComuns) || 45;

  const reservaItem = monthsConfig.find((m) => m.allocatedTo === "Reserva");
  if (reservaItem) {
    reservaItem.value = formatMoneyValue(
      Math.max(0, reservaItem.value - dc - valorComissao)
    );
    reservaItem.isPlatformGap = true;
  }
  if (monthsConfig.length > 1) {
    monthsConfig[lastIdx].value = formatMoneyValue(
      monthsConfig[lastIdx].value + dc
    );
    monthsConfig[lastIdx].isPlatformGapRecovered = true;
  }

  monthsConfig.forEach((m) => {
    if (m.allocatedTo === "Reserva") {
      const dataVencimentoReserva = stay.dataReserva || stay.checkIn;

      tranches.push({
        id: `${stay.id}-tranche-reserva`,
        stayId: stay.id,
        propriedade: stay.propriedade,
        quarto: stay.quarto,
        inquilino: stay.inquilino,
        fase: "RESERVA",
        titulo: "Garantia de Reserva",
        descricao:
          stay.origemCoolivin === "Sim"
            ? `Sinal líquido cobrado direto Coolivin. Deduzidos ${dc}€ de despesas comuns (a acertar no fecho).`
            : `Sinal líquido cobrado. Deduzidos ${dc}€ de despesas e ${valorComissao}€ de comissão retida pela plataforma ${
                stay.plataformaOrigem || "parceira"
              }.`,
        valorDevido: formatMoneyValue(m.value),
        valorRecebido: stay.status === "Ativo" ? formatMoneyValue(m.value) : 0,
        dataLimite: dataVencimentoReserva,
        dataRecebimento: stay.status === "Ativo" ? dataVencimentoReserva : "",
        status: stay.status === "Ativo" ? "Pago" : "Pendente",
        metodo: stay.status === "Ativo" ? "Transferência" : "",
        refFatura: "",
        corFase: "verde",
        detalhesTimeline: "DEVIDO COM A RESERVA",
        isHalfRent: m.isHalf,
        justificacaoHalf: m.justification,
        isPlatformGap: m.isPlatformGap || false,
        isPlatformCommissionDeducted: isPlatformBooking,
        comissaoRetida: valorComissao,
        despesasComunsValor: dc,
        mesReferencia: m.str,
        mesVencimento: dataVencimentoReserva.slice(0, 7),
      });
    } else if (m.allocatedTo === "CheckIn-MeiaRenda") {
      tranches.push({
        id: `${stay.id}-tranche-entrada-meia`,
        stayId: stay.id,
        propriedade: stay.propriedade,
        quarto: stay.quarto,
        inquilino: stay.inquilino,
        fase: "ENTRADA-MEIA",
        titulo: "Renda de Entrada (Meia Quinzena)",
        descricao: `Proporcional aos dias habitados de ${formatMonthPt(
          m.str
        )}.`,
        valorDevido: formatMoneyValue(m.value),
        valorRecebido: stay.status === "Ativo" ? formatMoneyValue(m.value) : 0,
        dataLimite: stay.checkIn,
        dataRecebimento: stay.status === "Ativo" ? stay.checkIn : "",
        status: stay.status === "Ativo" ? "Pago" : "Pendente",
        metodo: stay.status === "Ativo" ? "Transferência" : "",
        refFatura: "",
        corFase: "amarelo",
        detalhesTimeline: "DEVIDO NO CHECK-IN",
        isHalfRent: m.isHalf,
        justificacaoHalf: m.justification,
        isPlatformGap: false,
        mesReferencia: m.str,
        mesVencimento: stay.checkIn.slice(0, 7),
      });
    } else if (m.allocatedTo === "CheckIn-UltimoMes") {
      tranches.push({
        id: `${stay.id}-tranche-fim`,
        stayId: stay.id,
        propriedade: stay.propriedade,
        quarto: stay.quarto,
        inquilino: stay.inquilino,
        fase: "ENTRADA-CAUCAO",
        titulo: "Último Mês de Estadia",
        descricao: m.isPlatformGapRecovered
          ? `Renda final de fecho referente a ${formatMonthPt(
              m.str
            )}. Acrescido o acerto de ${dc}€ de despesas retidas no momento da reserva.`
          : `Renda final de fecho referente a ${formatMonthPt(
              m.str
            )}. Paga completa no check-in por segurança.`,
        valorDevido: formatMoneyValue(m.value),
        valorRecebido: stay.status === "Ativo" ? formatMoneyValue(m.value) : 0,
        dataLimite: stay.checkIn,
        dataRecebimento: stay.status === "Ativo" ? stay.checkIn : "",
        status: stay.status === "Ativo" ? "Pago" : "Pendente",
        metodo: stay.status === "Ativo" ? "Transferência" : "",
        refFatura: "",
        corFase: "amarelo",
        detalhesTimeline: "DEVIDO NO CHECK-IN",
        isHalfRent: m.isHalf,
        justificacaoHalf: m.justification,
        isPlatformGapRecovered: m.isPlatformGapRecovered || false,
        despesasComunsValor: dc,
        mesReferencia: m.str,
        mesVencimento: stay.checkIn.slice(0, 7),
      });
    } else {
      const mesAnterior = new Date(
        m.date.getFullYear(),
        m.date.getMonth() - 1,
        1
      );
      const ultimoDiaMesAnterior = new Date(
        mesAnterior.getFullYear(),
        mesAnterior.getMonth() + 1,
        0
      );
      const dataLimitePagamento = ultimoDiaMesAnterior
        .toISOString()
        .slice(0, 10);

      const hoje = new Date();
      const isPast = ultimoDiaMesAnterior < hoje;

      tranches.push({
        id: `${stay.id}-tranche-mensal-${m.str}`,
        stayId: stay.id,
        propriedade: stay.propriedade,
        quarto: stay.quarto,
        inquilino: stay.inquilino,
        fase: "MENSALIDADE",
        titulo: `Mensalidade de Renda`,
        descricao: m.isHalf
          ? `Renda de ${formatMonthPt(
              m.str
            )} reduzida. Acerto aplicado devido à saída antecipada.`
          : `Renda mensal integral referente a ${formatMonthPt(m.str)}.`,
        valorDevido: formatMoneyValue(m.value),
        valorRecebido: isPast ? formatMoneyValue(m.value) : 0,
        dataLimite: dataLimitePagamento,
        dataRecebimento: isPast ? dataLimitePagamento : "",
        status: isPast ? "Pago" : "Pendente",
        metodo: isPast ? "Transferência" : "",
        refFatura: "",
        corFase: "azul",
        detalhesTimeline: "DEVIDO ATÉ AO FIM DO MÊS ANTERIOR",
        isHalfRent: m.isHalf,
        justificacaoHalf: m.justification,
        isPlatformGap: false,
        mesReferencia: m.str,
        mesVencimento: dataLimitePagamento.slice(0, 7),
      });
    }
  });

  if (stay.adminFee && parseFloat(stay.adminFee) > 0) {
    const valorAdmin = parseFloat(stay.adminFee);
    const dataVencimentoReserva = stay.dataReserva || stay.checkIn;
    tranches.push({
      id: `${stay.id}-tranche-adminfee`,
      stayId: stay.id,
      propriedade: stay.propriedade,
      quarto: stay.quarto,
      inquilino: stay.inquilino,
      fase: "RESERVA",
      titulo: "Taxa Administrativa (Admin Fee)",
      descricao:
        "Taxa única operacional devida no momento da reserva para processamento de contrato.",
      valorDevido: formatMoneyValue(valorAdmin),
      valorRecebido: stay.status === "Ativo" ? formatMoneyValue(valorAdmin) : 0,
      dataLimite: dataVencimentoReserva,
      dataRecebimento: stay.status === "Ativo" ? dataVencimentoReserva : "",
      status: stay.status === "Ativo" ? "Pago" : "Pendente",
      metodo: stay.status === "Ativo" ? "Transferência" : "",
      refFatura: "",
      corFase: "verde",
      detalhesTimeline: "DEVIDO COM A RESERVA",
      isHalfRent: false,
      justificacaoHalf: "",
      mesReferencia: stay.checkIn.slice(0, 7),
      mesVencimento: dataVencimentoReserva.slice(0, 7),
    });
  }

  if (stay.caucao > 0) {
    tranches.push({
      id: `${stay.id}-tranche-caucao`,
      stayId: stay.id,
      propriedade: stay.propriedade,
      quarto: stay.quarto,
      inquilino: stay.inquilino,
      fase: "ENTRADA-CAUCAO",
      titulo: "Caução (Garantia)",
      descricao: "Valor de segurança reembolsável após vistorias no check-out.",
      valorDevido: formatMoneyValue(stay.caucao),
      valorRecebido:
        stay.status === "Ativo" ? formatMoneyValue(stay.caucao) : 0,
      dataLimite: stay.checkIn,
      dataRecebimento: stay.status === "Ativo" ? stay.checkIn : "",
      status: stay.status === "Ativo" ? "Pago" : "Pendente",
      metodo: stay.status === "Ativo" ? "Transferência" : "",
      refFatura: "",
      corFase: "amarelo",
      detalhesTimeline: "DEVIDO NO CHECK-IN",
      isHalfRent: false,
      justificacaoHalf: "",
      mesReferencia: stay.checkIn.slice(0, 7),
      mesVencimento: stay.checkIn.slice(0, 7),
    });
  }

  return tranches.sort(
    (a, b) =>
      new Date(a.dataLimite).getTime() - new Date(b.dataLimite).getTime()
  );
};

const CoolivinLogoSvg = ({ className = "h-9 w-auto text-slate-955" }) => (
  <svg viewBox="0 0 160 40" className={className} fill="currentColor">
    <path d="M 12 24 C 12 18, 16 14, 21 14 C 25 14, 28 17, 28 20 L 23.5 20 C 23.5 18.5, 22.5 17.5, 21 17.5 C 18.5 17.5, 16.5 19.5, 16.5 24 C 16.5 28.5, 18.5 30.5, 21 30.5 C 22.5 30.5, 23.5 29.5, 23.5 28 L 28 28 C 28 31, 25 33.5, 21 33.5 C 16 33.5, 12 30, 12 24 Z" />
    <path d="M 32 24 C 32 18, 37 14, 43 14 C 49 14, 54 18, 54 24 C 54 30, 49 33.5, 43 33.5 C 37 33.5, 32 30, 32 24 Z M 36.5 24 C 36.5 28, 38.5 30, 43 30 C 47.5 30, 49.5 28, 49.5 24 C 49.5 20, 47.5 17.5, 43 17.5 C 38.5 17.5, 36.5 20, 36.5 24 Z" />
    <path d="M 58 24 C 58 18, 63 14, 69 14 C 75 14, 80 18, 80 24 C 80 30, 75 33.5, 69 33.5 C 63 33.5, 58 30, 58 24 Z M 62.5 24 C 62.5 28, 64.5 30, 69 30 C 73.5 30, 75.5 28, 75.5 24 C 75.5 20, 74.5 17.5, 69 17.5 C 64.5 17.5, 62.5 20, 62.5 24 Z" />
    <rect x="84" y="9" width="4" height="24" rx="1" />
    <rect x="92" y="15" width="4" height="18" rx="1" />
    <path d="M 100 15 L 104.5 15 L 109 26.5 L 113.5 15 L 118 15 L 111.5 33 L 106.5 33 Z" />
    <rect x="122" y="15" width="4" height="18" rx="1" />
    <path d="M 130 15 L 134 15 L 134 18 C 136 15.5, 139 14, 143 14 C 147 14, 149.5 16, 149.5 21 L 149.5 33 L 145.5 33 L 145.5 21 C 145.5 18.5, 144 17.5, 141 17.5 C 137.5 17.5, 134 19.5, 134 23 L 134 33 L 130 33 Z" />
    <circle
      cx="155"
      cy="11"
      r="3.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.8"
    />
    <text
      x="153.5"
      y="13"
      fontSize="5.5"
      fontWeight="black"
      fontFamily="sans-serif"
    >
      c
    </text>
  </svg>
);

// ==========================================
// COMPONENTE PRINCIPAL App
// ==========================================
export default function App() {
  const [activeTab, setActiveTab] = useState("overview");
  const [selectedPropriedade, setSelectedPropriedade] = useState("Saldanha 3#");
  const [activeMonth, setActiveMonth] = useState("2026-06");
  const [selectedInquilinoId, setSelectedInquilinoId] = useState(null);
  const [filterType, setFilterType] = useState("vencimento");
  const [cronogramaSearchTerm, setCronogramaSearchTerm] = useState("");
  const [recebimentosViewMode, setRecebimentosViewMode] =
    useState("lista-geral");
  const [user, setUser] = useState(null);
  const [selectedCalendarYear, setSelectedCalendarYear] = useState(2026);
  const [isTenantPanelExpanded, setIsTenantPanelExpanded] = useState(true);

  const [sidebarStatusFilter, setSidebarStatusFilter] = useState("Todos");
  const [sidebarRoomFilter, setSidebarRoomFilter] = useState("");
  const [sidebarPropFilter, setSidebarPropFilter] = useState("Todos");
  const [cursorDate, setCursorDate] = useState(new Date());

  const [listFaturacaoFilter, setListFaturacaoFilter] = useState("Todos");

  const [collapsedProperties, setCollapsedProperties] = useState({});
  const [calendarViewMode, setCalendarViewMode] = useState("anual");
  const [selectedDetailMonth, setSelectedDetailMonth] = useState(5);

  const togglePropertyCollapse = (prop) => {
    setCollapsedProperties((prev) => ({
      ...prev,
      [prop]: !prev[prop],
    }));
  };

  useEffect(() => {
    const tailwindScript = document.createElement("script");
    tailwindScript.src = "https://cdn.tailwindcss.com";
    document.head.appendChild(tailwindScript);

    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap";
    document.head.appendChild(fontLink);

    const extraStyle = document.createElement("style");
    extraStyle.innerHTML = `
      body, html {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
      }
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes scaleUp {
        from { transform: scale(0.97); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
      .animate-fadeIn { animation: fadeIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
      .animate-scaleUp { animation: scaleUp 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    `;
    document.head.appendChild(extraStyle);

    return () => {
      if (document.head.contains(tailwindScript))
        document.head.removeChild(tailwindScript);
      if (document.head.contains(fontLink)) document.head.removeChild(fontLink);
      if (document.head.contains(extraStyle))
        document.head.removeChild(extraStyle);
    };
  }, []);

  const [db, setDb] = useState(null);
  const [auth, setAuth] = useState(null);
  const firebaseEnabled = true;

  useEffect(() => {
    try {
      const app =
        getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
      setDb(getFirestore(app));
      setAuth(getAuth(app));
    } catch (e) {
      console.error("Erro ao inicializar o Firebase automaticamente:", e);
    }
  }, []);

  useEffect(() => {
    if (!auth) return;
    const initAuth = async () => {
      try {
        await signInAnonymously(auth);
      } catch (e) {
        console.error("Autenticação anónima automática falhou:", e);
      }
    };
    initAuth();
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, [auth]);

  const [stays, setStays] = useState(() => {
    const saved = localStorage.getItem("coolivin_stays");
    return saved ? JSON.parse(saved) : DEMO_STAYS;
  });

  const [receipts, setReceipts] = useState(() => {
    const saved = localStorage.getItem("coolivin_receipts");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    if (!db || !user) return;

    const unsubStays = onSnapshot(
      collection(db, "artifacts", APP_ID_FIXO, "public", "data", "stays"),
      (snapshot) => {
        const items = [];
        snapshot.forEach((doc) => {
          items.push({ id: doc.id, ...doc.data() });
        });
        if (items.length > 0) {
          setStays(items);
          if (selectedInquilinoId === null) {
            setSelectedInquilinoId(items[0].id);
          }
        }
      },
      (error) => console.error("Erro ao escutar estadias:", error)
    );

    const unsubReceipts = onSnapshot(
      collection(db, "artifacts", APP_ID_FIXO, "public", "data", "receipts"),
      (snapshot) => {
        const items = [];
        snapshot.forEach((doc) => {
          items.push({ id: doc.id, ...doc.data() });
        });
        if (items.length > 0) setReceipts(items);
      },
      (error) => console.error("Erro ao escutar tranches:", error)
    );

    return () => {
      unsubStays();
      unsubReceipts();
    };
  }, [db, user]);

  useEffect(() => {
    if (!firebaseEnabled) {
      localStorage.setItem("coolivin_stays", JSON.stringify(stays));
    }
  }, [stays]);

  useEffect(() => {
    if (!firebaseEnabled) {
      localStorage.setItem("coolivin_receipts", JSON.stringify(receipts));
    }
  }, [receipts]);

  const persistDoc = async (colName, docId, data) => {
    if (db && user) {
      try {
        await setDoc(
          doc(
            db,
            "artifacts",
            APP_ID_FIXO,
            "public",
            "data",
            colName,
            String(docId)
          ),
          data,
          { merge: true }
        );
      } catch (err) {
        console.error("Erro ao persistir documento no Firestore:", err);
      }
    }
  };

  const obterStatusRealStay = (stay) => {
    if (!stay.checkOut) return stay.status || "Ativo";
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const dataFim = new Date(stay.checkOut);
    dataFim.setHours(0, 0, 0, 0);
    if (dataFim <= hoje) {
      return "Concluído";
    }
    return stay.status || "Ativo";
  };

  const deletePersistedDoc = async (colName, docId) => {
    if (db && user) {
      try {
        await deleteDoc(
          doc(
            db,
            "artifacts",
            APP_ID_FIXO,
            "public",
            "data",
            colName,
            String(docId)
          )
        );
      } catch (err) {
        console.error("Erro ao apagar documento no Firestore:", err);
      }
    }
  };

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  const triggerConfirmation = (title, message, callback) => {
    setConfirmModal({
      isOpen: true,
      title,
      message,
      onConfirm: () => {
        callback();
        setConfirmModal((prev) => ({ ...prev, isOpen: false }));
      },
    });
  };

  const [rawCsvPaste, setRawCsvPaste] = useState("");
  const [syncMessage, setSyncMessage] = useState({ type: "", text: "" });

  const [newStay, setNewStay] = useState({
    propriedade: "Saldanha 3#",
    quarto: "Quarto 1",
    inquilino: "",
    renda: "",
    caucao: "",
    adminFee: "",
    despesasComuns: "45",
    dataReserva: new Date().toISOString().slice(0, 10),
    checkIn: "",
    checkOut: "",
    checkInComunicado: "",
    checkOutComunicado: "",
    email: "",
    telemovel: "",
    nacionalidade: "",
    ocupacao: "Trabalhador",
    universidade: "",
    idade: "",
    ofertaEspecial: "Não",
    codigoOferta: "",
    origemCoolivin: "Sim",
    plataformaOrigem: "",
    comissaoValor: "",
    status: "Ativo",
    notas: "",
  });

  const [quickReceiptData, setQuickReceiptData] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("Todos");
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("Todos");

  const focarInquilinoNaTimeline = (inquilinoId) => {
    setSelectedInquilinoId(inquilinoId);
    setRecebimentosViewMode("timeline");
    setActiveTab("recebimentos");
  };

  const handleAddStaySubmit = async (e) => {
    e.preventDefault();
    if (
      !newStay.inquilino ||
      !newStay.renda ||
      !newStay.checkIn ||
      !newStay.checkOut ||
      !newStay.dataReserva
    ) {
      setSyncMessage({
        type: "error",
        text: "Preenche os campos obrigatórios de Contrato e Reserva!",
      });
      return;
    }

    const stayId = Date.now();
    const createdStay = {
      id: stayId,
      ...newStay,
      renda: parseFloat(newStay.renda),
      caucao: parseFloat(newStay.caucao) || 0,
      adminFee: parseFloat(newStay.adminFee) || 0,
      despesasComuns: parseFloat(newStay.despesasComuns) || 45,
      idade: parseInt(newStay.idade, 10) || "",
    };

    await persistDoc("stays", stayId, createdStay);
    const generatedTranches = calcularTranchesDeEstadia(createdStay);
    for (const tranche of generatedTranches) {
      await persistDoc("receipts", tranche.id, tranche);
    }

    setNewStay({
      propriedade: "Saldanha 3#",
      quarto: "Quarto 1",
      inquilino: "",
      renda: "",
      caucao: "",
      adminFee: "",
      despesasComuns: "45",
      dataReserva: new Date().toISOString().slice(0, 10),
      checkIn: "",
      checkOut: "",
      checkInComunicado: "",
      checkOutComunicado: "",
      email: "",
      telemovel: "",
      nacionalidade: "",
      ocupacao: "Trabalhador",
      universidade: "",
      idade: "",
      ofertaEspecial: "Não",
      codigoOferta: "",
      origemCoolivin: "Sim",
      plataformaOrigem: "",
      comissaoValor: "",
      status: "Ativo",
      notas: "",
    });

    setSyncMessage({
      type: "success",
      text: `Inquilino ${createdStay.inquilino} registado com todas as fichas CRM!`,
    });
    setTimeout(() => setSyncMessage({ type: "", text: "" }), 5000);
    focarInquilinoNaTimeline(stayId);
  };

  const handleTranchePayConfirm = async (e) => {
    e.preventDefault();
    if (!quickReceiptData) return;

    const valDev = parseFloat(quickReceiptData.valorDevido) || 0;
    const valRec = parseFloat(quickReceiptData.valorRecebido) || 0;

    let status = "Pendente";
    if (valRec >= valDev) {
      status = "Pago";
    } else if (valRec > 0) {
      status = "Parcial";
    }

    const updatedTranche = {
      ...quickReceiptData,
      valorDevido: valDev,
      valorRecebido: valRec,
      dataRecebimento:
        quickReceiptData.dataRecebimento ||
        new Date().toISOString().slice(0, 10),
      metodo: quickReceiptData.metodo || "Transferência",
      refFatura: quickReceiptData.refFatura || "",
      status: status,
      notes: quickReceiptData.notas || "",
      notas: quickReceiptData.notas || "",
    };

    await persistDoc("receipts", quickReceiptData.id, updatedTranche);

    setQuickReceiptData(null);
    setSyncMessage({
      type: "success",
      text: "Tranche updated successfully!",
    });
    setTimeout(() => setSyncMessage({ type: "", text: "" }), 3500);
  };

  const handleCsvImport = async () => {
    try {
      if (!rawCsvPaste.trim()) {
        setSyncMessage({ type: "error", text: "Cola dados CSV válidos." });
        return;
      }

      const lines = rawCsvPaste.split("\n");
      if (lines.length < 2) {
        setSyncMessage({ type: "error", text: "Formato inválido." });
        return;
      }

      const headerLine = lines[0];
      const delimiter = headerLine.includes(";") ? ";" : ",";

      const newStays = [];
      const newReceipts = [];

      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        const cols = lines[i]
          .split(delimiter)
          .map((c) => c.trim().replace(/^["']|["']$/g, ""));

        let prop = cols[0] || "Saldanha 3#";
        if (!prop.endsWith("#") && PROPRIEDADES.includes(prop + "#")) {
          prop = prop + "#";
        }

        const stayId = Date.now() + i;
        const rowObj = {
          id: stayId,
          propriedade: PROPRIEDADES.includes(prop) ? prop : "Saldanha 3#",
          quarto: cols[1] || `Quarto ${i}`,
          inquilino: cols[2] || "Inquilino Pendente",
          renda: parseFloat(cols[3]) || 0,
          caucao: parseFloat(cols[4]) || 0,
          adminFee: parseFloat(cols[9]) || 0,
          despesasComuns: parseFloat(cols[10]) || 45,
          dataReserva: new Date().toISOString().slice(0, 10),
          checkIn: cols[5] || "2026-02-01",
          checkOut: cols[6] || "2026-07-31",
          checkInComunicado: cols[5] || "",
          checkOutComunicado: cols[6] || "",
          email: "",
          telemovel: "",
          nacionalidade: "",
          ocupacao: "Trabalhador",
          universidade: "",
          idade: "",
          ofertaEspecial: "Não",
          codigoOferta: "",
          origemCoolivin: "Sim",
          plataformaOrigem: "",
          comissaoValor: "",
          status: cols[7] || "Ativo",
          notas: cols[8] || "",
        };

        newStays.push(rowObj);
        const tranches = calcularTranchesDeEstadia(rowObj);
        tranches.forEach((t) => newReceipts.push(t));
      }

      if (newStays.length > 0) {
        for (const s of newStays) {
          await persistDoc("stays", s.id, s);
        }
        for (const r of newReceipts) {
          await persistDoc("receipts", r.id, r);
        }
        setSyncMessage({
          type: "success",
          text: `Sucesso! Importados ${newStays.length} inquilinos.`,
        });
        setRawCsvPaste("");
        setActiveTab("recebimentos");
      }
    } catch (err) {
      setSyncMessage({
        type: "error",
        text: "Erro ao importar CSV: " + err.message,
      });
    }
  };

  const startEdit = (stay) => {
    setEditingId(stay.id);
    setEditFormData({ ...stay });
  };

  const saveEdit = async (id) => {
    const editedStay = {
      ...editFormData,
      renda: parseFloat(editFormData.renda) || 0,
      caucao: parseFloat(editFormData.caucao) || 0,
      adminFee: parseFloat(editFormData.adminFee) || 0,
      despesasComuns: parseFloat(editFormData.despesasComuns) || 45,
      idade: parseInt(editFormData.idade, 10) || "",
    };

    await persistDoc("stays", id, editedStay);
    setEditingId(null);

    triggerConfirmation(
      "Atualizar Plano de Pagamentos",
      "Desejas recalcular o plano de tranches para este inquilino devido à alteração de contrato?",
      async () => {
        const newTranches = calcularTranchesDeEstadia(editedStay);
        const oldRelated = receipts.filter((r) => r.stayId === id);
        for (const old of oldRelated) {
          await deletePersistedDoc("receipts", old.id);
        }
        for (const tranche of newTranches) {
          await persistDoc("receipts", tranche.id, tranche);
        }
        setSyncMessage({
          type: "success",
          text: "Plano de tranches quinzenais actualizado com sucesso.",
        });
      }
    );
  };

  const deleteStay = (id) => {
    const matched = stays.find((s) => s.id === id);
    triggerConfirmation(
      "Remover Estadia",
      `Tem a certeza que deseja apagar a estadia de ${matched?.inquilino}? Isto irá apagar também todas as tranches associadas.`,
      async () => {
        await deletePersistedDoc("stays", id);
        const oldRelated = receipts.filter((r) => r.stayId === id);
        for (const old of oldRelated) {
          await deletePersistedDoc("receipts", old.id);
        }
        setSyncMessage({
          type: "success",
          text: "Inquilino e cronograma removidos com sucesso.",
        });
        setTimeout(() => setSyncMessage({ type: "", text: "" }), 3000);
      }
    );
  };

  const deleteReceipt = (id) => {
    triggerConfirmation(
      "Remover Tranche de Pagamento",
      "Tem a certeza que pretende apagar esta tranche de fatura individual?",
      async () => {
        await deletePersistedDoc("receipts", id);
      }
    );
  };

  const handleResetData = () => {
    triggerConfirmation(
      "Limpar Todo o Sistema",
      "Tem a certeza que deseja eliminar permanentemente TODAS as estadias e tranches do sistema para começar de novo do zero?",
      async () => {
        setSyncMessage({
          type: "info",
          text: "A eliminar registos do Firebase...",
        });
        for (const s of stays) {
          await deletePersistedDoc("stays", s.id);
        }
        for (const r of receipts) {
          await deletePersistedDoc("receipts", r.id);
        }
        setSelectedInquilinoId(null);
        setSyncMessage({
          type: "success",
          text: "Base de dados limpa com sucesso. Pronto para inserção real!",
        });
        setTimeout(() => setSyncMessage({ type: "", text: "" }), 4000);
      }
    );
  };

  const handleLoadDemoData = () => {
    triggerConfirmation(
      "Carregar Dados de Demonstração",
      "Isto irá carregar as duas estadias fictícias de teste (Camila Miguel e Beatriz Reis) para poderes ver as nuances quinzenais e de comissões em pleno funcionamento. Pretendes continuar?",
      async () => {
        setSyncMessage({
          type: "info",
          text: "A carregar dados no Firebase...",
        });
        for (const s of DEMO_STAYS) {
          await persistDoc("stays", s.id, s);
          const tranches = calcularTranchesDeEstadia(s);
          for (const t of tranches) {
            await persistDoc("receipts", t.id, t);
          }
        }
        setSelectedInquilinoId(1001);
        setSyncMessage({
          type: "success",
          text: "Dados de demonstração carregados com sucesso!",
        });
        setTimeout(() => setSyncMessage({ type: "", text: "" }), 4000);
      }
    );
  };

  // Gantt Matrix
  const startOfSelectedYear = new Date(
    `${selectedCalendarYear}-01-01T00:00:00`
  );
  const endOfSelectedYear = new Date(`${selectedCalendarYear}-12-31T23:59:59`);
  const totalCalendarYearMs =
    endOfSelectedYear.getTime() - startOfSelectedYear.getTime();

  const propertyRoomsMatrix = {};
  PROPRIEDADES.forEach((p) => {
    propertyRoomsMatrix[p] = {};
  });

  stays.forEach((stay) => {
    const p = stay.propriedade;
    const r = stay.quarto;
    if (propertyRoomsMatrix[p]) {
      if (!propertyRoomsMatrix[p][r]) {
        propertyRoomsMatrix[p][r] = [];
      }
      propertyRoomsMatrix[p][r].push(stay);
    }
  });

  // Métricas
  const totalRendasPrevistasGlobal = receipts.reduce(
    (acc, curr) => acc + curr.valorDevido,
    0
  );
  const totalRendasPagasGlobal = receipts
    .filter((r) => r.status === "Pago")
    .reduce((acc, curr) => acc + curr.valorRecebido, 0);
  const totalRendasPendentesGlobal = receipts
    .filter((r) => r.status === "Pendente" || r.status === "Parcial")
    .reduce((acc, curr) => acc + (curr.valorDevido - curr.valorRecebido), 0);

  const activeContracts = stays.filter((s) => s.status === "Ativo");
  const receitaMensalEsperada = activeContracts.reduce(
    (acc, curr) => acc + curr.renda,
    0
  );

  const filteredReceiptsList = receipts.filter((receipt) => {
    const targetMonthField =
      filterType === "vencimento"
        ? receipt.mesVencimento
        : receipt.mesReferencia;
    const matchMonth = targetMonthField === activeMonth;

    let matchStatus = true;
    if (paymentStatusFilter === "Pago") {
      matchStatus = receipt.status === "Pago";
    } else if (paymentStatusFilter === "Pendente") {
      matchStatus =
        receipt.status === "Pendente" || receipt.status === "Parcial";
    }

    let matchFaturacao = true;
    if (listFaturacaoFilter === "Com Fatura") {
      matchFaturacao = !!receipt.refFatura;
    } else if (listFaturacaoFilter === "Falta Fatura") {
      matchFaturacao = !receipt.refFatura;
    }

    return matchMonth && matchStatus && matchFaturacao;
  });

  const totalEsperadoMesFiltrado = filteredReceiptsList.reduce(
    (acc, curr) => acc + curr.valorDevido,
    0
  );
  const totalPagoMesFiltrado = filteredReceiptsList
    .filter((r) => r.status === "Pago")
    .reduce((acc, curr) => acc + curr.valorRecebido, 0);
  const totalFaltaMesFiltrado = Math.max(
    0,
    totalEsperadoMesFiltrado - totalPagoMesFiltrado
  );

  const propertyAnalysis = PROPRIEDADES.map((prop, idx) => {
    const propStays = stays.filter((s) => s.propriedade === prop);
    const propActive = propStays.filter((s) => s.status === "Ativo");
    const propRevenue = propActive.reduce((acc, curr) => acc + curr.renda, 0);
    const propReservations = propStays.filter(
      (s) => s.status === "Reservado"
    ).length;

    return {
      name: prop,
      value: propRevenue,
      inquilinos: propActive.length,
      reservas: propReservations,
      color: GRAPH_COLORS[idx % GRAPH_COLORS.length],
    };
  }).filter((p) => p.value > 0 || p.inquilinos > 0 || p.reservas > 0);

  const chartPieData =
    propertyAnalysis.length > 0
      ? propertyAnalysis
      : [{ name: "Sem dados", value: 0, color: "#94a3b8" }];

  const monthlyFlowData = [
    { month: "Jan", Receitas: receitaMensalEsperada * 0.8 },
    { month: "Fev", Receitas: receitaMensalEsperada * 0.9 },
    { month: "Mar", Receitas: receitaMensalEsperada * 1.1 },
    { month: "Abr", Receitas: receitaMensalEsperada },
    { month: "Mai", Receitas: receitaMensalEsperada * 1.05 },
    {
      month: "Jun",
      Receitas: totalRendasPagasGlobal * 0.25 || receitaMensalEsperada,
    },
  ];

  const selectedPropertyStays = stays.filter((s) => {
    const matchProp = s.propriedade === selectedPropriedade;
    const matchSearch =
      s.inquilino.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.quarto.toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = statusFilter === "Todos" || s.status === statusFilter;
    return matchProp && matchSearch && matchStatus;
  });

  const filteredStaysForTimeline = stays.filter((s) => {
    const matchSearch = s.inquilino
      .toLowerCase()
      .includes(cronogramaSearchTerm.toLowerCase());
    const matchStatus =
      sidebarStatusFilter === "Todos" || s.status === sidebarStatusFilter;
    const matchRoom =
      sidebarRoomFilter === "" ||
      s.quarto.toLowerCase().includes(sidebarRoomFilter.toLowerCase());
    const matchProp =
      sidebarPropFilter === "Todos" || s.propriedade === sidebarPropFilter;
    return matchSearch && matchStatus && matchRoom && matchProp;
  });

  const currentInquilinoStay =
    stays.find((s) => s.id === selectedInquilinoId) || stays[0] || null;
  const currentInquilinoTranches = currentInquilinoStay
    ? receipts.filter((r) => r.stayId === currentInquilinoStay.id)
    : [];

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans text-slate-800 antialiased text-xs">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center gap-3">
              <CoolivinLogoSvg className="h-8 sm:h-9 w-auto text-slate-900" />
              <div className="border-l border-slate-200 pl-3 flex items-center gap-2">
                <span className="text-[10px] tracking-wider text-slate-400 uppercase font-black block">
                  Dashboard de Equipas
                </span>
                <span className="bg-emerald-100 text-emerald-800 text-[9px] px-2 py-0.5 rounded font-black flex items-center gap-1">
                  <Database className="h-2.5 w-2.5" /> CLOUD CONECTADA (AUTOMÁTICO)
                </span>
              </div>
            </div>

            <nav className="hidden lg:flex items-center space-x-1">
              <button
                onClick={() => setActiveTab("overview")}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold transition-all ${
                  activeTab === "overview"
                    ? "bg-slate-100 text-slate-900 font-extrabold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <LayoutDashboard className="h-4 w-4" /> Painel Geral
              </button>
              <button
                onClick={() => {
                  setActiveTab("properties");
                  setSelectedPropriedade("Saldanha 3#");
                }}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold transition-all ${
                  activeTab === "properties"
                    ? "bg-slate-100 text-slate-900 font-extrabold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <Home className="h-4 w-4" /> Casas ({PROPRIEDADES.length})
              </button>
              <button
                onClick={() => setActiveTab("calendar")}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold transition-all ${
                  activeTab === "calendar"
                    ? "bg-slate-100 text-slate-900 font-extrabold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <CalendarDays className="h-4 w-4 text-indigo-600" /> Calendário de Ocupação
              </button>
              <button
                onClick={() => setActiveTab("causoes")}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold transition-all ${
                  activeTab === "causoes"
                    ? "bg-slate-100 text-slate-900 font-extrabold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <Gift className="h-4 w-4 text-amber-600" /> Devolução de Cauções
              </button>
              <button
                onClick={() => setActiveTab("recebimentos")}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold transition-all ${
                  activeTab === "recebimentos"
                    ? "bg-slate-100 text-slate-955 font-extrabold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <CreditCard className="h-4 w-4 text-slate-900" /> Recebimentos por Tranches
              </button>
            </nav>

            <div className="flex items-center gap-2">
              <button
                onClick={() => setActiveTab("addStay")}
                className="bg-slate-950 hover:bg-slate-900 text-white flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold shadow-sm transition-all"
              >
                <PlusCircle className="h-4 w-4" />{" "}
                <span className="hidden sm:inline">Nova Estadia</span>
              </button>
              <button
                onClick={() => setActiveTab("sync")}
                className="p-2.5 text-slate-600 hover:text-slate-900 rounded-xl hover:bg-slate-50 transition-colors border border-slate-200 shadow-sm"
                title="Sincronização"
              >
                <Settings className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Menu Mobile */}
      <div className="lg:hidden bg-white border-b border-slate-200 flex justify-around p-2.5 text-[10px] font-black text-slate-600 sticky top-16 z-25 shadow-sm">
        <button
          onClick={() => setActiveTab("overview")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "overview" ? "text-slate-900 bg-slate-50 font-black" : ""
          }`}
        >
          <LayoutDashboard className="h-4 w-4" /> <span>Geral</span>
        </button>
        <button
          onClick={() => setActiveTab("properties")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "properties" ? "text-slate-900 bg-slate-50 font-black" : ""
          }`}
        >
          <Home className="h-4 w-4" /> <span>Casas</span>
        </button>
        <button
          onClick={() => setActiveTab("calendar")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "calendar" ? "text-slate-900 bg-slate-50 font-black" : ""
          }`}
        >
          <CalendarDays className="h-4 w-4" /> <span>Agenda</span>
        </button>
        <button
          onClick={() => setActiveTab("causoes")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "causoes" ? "text-slate-900 bg-slate-50 font-black" : ""
          }`}
        >
          <Gift className="h-4 w-4 text-amber-600" /> <span>Cauções</span>
        </button>
        <button
          onClick={() => setActiveTab("recebimentos")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "recebimentos" ? "text-slate-900 bg-slate-50 font-black text-black" : ""
          }`}
        >
          <CreditCard className="h-4 w-4" /> <span>Rendas</span>
        </button>
        <button
          onClick={() => setActiveTab("sync")}
          className={`flex flex-col items-center gap-1 px-2.5 py-1 rounded-lg ${
            activeTab === "sync" ? "text-slate-900 bg-slate-50 font-black" : ""
          }`}
        >
          <Settings className="h-4 w-4" /> <span>Config</span>
        </button>
      </div>

      <main className="flex-grow max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {syncMessage.text && (
          <div
            className={`mb-6 p-4 rounded-xl flex items-center justify-between border ${
              syncMessage.type === "error"
                ? "bg-red-50 border-red-200 text-red-800"
                : "bg-emerald-50 border-emerald-200 text-emerald-800"
            }`}
          >
            <div className="flex items-center gap-2">
              <Info className="h-4 w-4" />
              <p className="font-bold text-xs">{syncMessage.text}</p>
            </div>
            <button
              onClick={() => setSyncMessage({ type: "", text: "" })}
              className="font-bold opacity-60 hover:opacity-100"
            >
              ✕
            </button>
          </div>
        )}

        {activeTab === "overview" && (
          <DashboardTab
            receitaMensalEsperada={receitaMensalEsperada}
            totalRendasPagasGlobal={totalRendasPagasGlobal}
            totalRendasPrevistasGlobal={totalRendasPrevistasGlobal}
            totalRendasPendentesGlobal={totalRendasPendentesGlobal}
            PROPRIEDADES={PROPRIEDADES}
            stays={stays}
            setSelectedPropriedade={setSelectedPropriedade}
            setActiveTab={setActiveTab}
            monthlyFlowData={monthlyFlowData}
            chartPieData={chartPieData}
          />
        )}

        {activeTab === "properties" && (
          <PropertiesTab
            PROPRIEDADES={PROPRIEDADES}
            selectedPropriedade={selectedPropriedade}
            setSelectedPropriedade={setSelectedPropriedade}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            sidebarStatusFilter={sidebarStatusFilter}
            setSidebarStatusFilter={setSidebarStatusFilter}
            setNewStay={setNewStay}
            setActiveTab={setActiveTab}
            selectedPropertyStays={selectedPropertyStays}
            focarInquilinoNaTimeline={focarInquilinoNaTimeline}
            formatDateToPt={formatDateToPt}
            obterStatusRealStay={obterStatusRealStay}
            startEdit={startEdit}
            deleteStay={deleteStay}
          />
        )}

        {activeTab === "calendar" && (
          <CalendarTab
            cursorDate={cursorDate}
            setCursorDate={setCursorDate}
            selectedCalendarYear={selectedCalendarYear}
            setSelectedCalendarYear={setSelectedCalendarYear}
            setSelectedDetailMonth={setSelectedDetailMonth}
            calendarViewMode={calendarViewMode}
            setCalendarViewMode={setCalendarViewMode}
            PROPRIEDADES={PROPRIEDADES}
            propertyRoomsMatrix={propertyRoomsMatrix}
            collapsedProperties={collapsedProperties}
            togglePropertyCollapse={togglePropertyCollapse}
            parseDateAgnostic={parseDateAgnostic}
            obterStatusRealStay={obterStatusRealStay}
            focarInquilinoNaTimeline={focarInquilinoNaTimeline}
          />
        )}

        {activeTab === "recebimentos" && (
          <ReceiptsTab
            recebimentosViewMode={recebimentosViewMode}
            setRecebimentosViewMode={setRecebimentosViewMode}
            cronogramaSearchTerm={cronogramaSearchTerm}
            setCronogramaSearchTerm={setCronogramaSearchTerm}
            sidebarStatusFilter={sidebarStatusFilter}
            setSidebarStatusFilter={setSidebarStatusFilter}
            sidebarRoomFilter={sidebarRoomFilter}
            setSidebarRoomFilter={setSidebarRoomFilter}
            sidebarPropFilter={sidebarPropFilter}
            setSidebarPropFilter={setSidebarPropFilter}
            PROPRIEDADES={PROPRIEDADES}
            filteredStaysForTimeline={filteredStaysForTimeline}
            receipts={receipts}
            selectedInquilinoId={selectedInquilinoId}
            setSelectedInquilinoId={setSelectedInquilinoId}
            currentInquilinoStay={currentInquilinoStay}
            isTenantPanelExpanded={isTenantPanelExpanded}
            setIsTenantPanelExpanded={setIsTenantPanelExpanded}
            setEditFormData={setEditFormData}
            setEditingId={setEditingId}
            currentInquilinoTranches={currentInquilinoTranches}
            formatMonthPt={formatMonthPt}
            formatDateToPt={formatDateToPt}
            filterType={filterType}
            setFilterType={setFilterType}
            activeMonth={activeMonth}
            setActiveMonth={setActiveMonth}
            paymentStatusFilter={paymentStatusFilter}
            setPaymentStatusFilter={setPaymentStatusFilter}
            listFaturacaoFilter={listFaturacaoFilter}
            setListFaturacaoFilter={setListFaturacaoFilter}
            totalEsperadoMesFiltrado={totalEsperadoMesFiltrado}
            totalPagoMesFiltrado={totalPagoMesFiltrado}
            totalFaltaMesFiltrado={totalFaltaMesFiltrado}
            filteredReceiptsList={filteredReceiptsList}
            focarInquilinoNaTimeline={focarInquilinoNaTimeline}
            setQuickReceiptData={setQuickReceiptData}
          />
        )}

        {activeTab === "sync" && (
          <SyncTab 
            rawCsvPaste={rawCsvPaste}
            setRawCsvPaste={setRawCsvPaste}
            handleCsvImport={handleCsvImport}
            handleResetData={handleResetData}
          />
        )}

        {activeTab === "causoes" && (
          <RefundsTab
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            sidebarStatusFilter={sidebarStatusFilter}
            setSidebarStatusFilter={setSidebarStatusFilter}
            sidebarPropFilter={sidebarPropFilter}
            setSidebarPropFilter={setSidebarPropFilter}
            sidebarRoomFilter={sidebarRoomFilter}
            setSidebarRoomFilter={setSidebarRoomFilter}
            PROPRIEDADES={PROPRIEDADES}
            stays={stays}
            receipts={receipts}
            formatDateToPt={formatDateToPt}
            setActiveTab={setActiveTab}
            focarInquilinoNaTimeline={focarInquilinoNaTimeline}
            setQuickReceiptData={setQuickReceiptData}
          />
        )}

        {activeTab === "addStay" && (
          <AddStayTab
            newStay={newStay}
            setNewStay={setNewStay}
            PROPRIEDADES={PROPRIEDADES}
            handleAddStaySubmit={handleAddStaySubmit}
          />
        )}
      </main>

      <footer className="bg-white border-t border-slate-200 py-6 mt-12 text-center text-slate-400">
        <p>© 2026 Coolivin®. Sistema de Faturação em Tranches Quinzenais (Regra de Devolução de Cauções).</p>
      </footer>

      {/* MODALS CONFIRMAÇÃO & VALIDAÇÃO */}
      {confirmModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl max-w-sm w-full p-6 shadow-xl border">
            <h3 className="text-base font-extrabold text-slate-900 flex items-center gap-2">
              <AlertTriangle className="text-amber-500 h-5 w-5" /> {confirmModal.title}
            </h3>
            <p className="text-xs text-slate-500 mt-3 leading-relaxed">{confirmModal.message}</p>
            <div className="flex gap-3 mt-6">
              <button onClick={confirmModal.onConfirm} className="flex-1 bg-slate-950 text-white font-bold py-2.5 rounded-xl shadow">Confirmar</button>
              <button onClick={() => setConfirmModal((prev) => ({ ...prev, isOpen: false }))} className="flex-1 bg-slate-100 text-slate-700 font-bold py-2.5 rounded-xl">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL GLOBAL INTELIGENTE: RENDAS E ACERTOS DE CAUÇÃO */}
      {quickReceiptData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white rounded-3xl max-w-lg w-full p-6 border shadow-2xl max-h-[92vh] overflow-y-auto">
            <h3 className="text-base font-black mb-4">
              {quickReceiptData.isCaucaoAjuste
                ? `Acerto Final de Caução — ${quickReceiptData.inquilino}`
                : `Validar / Modificar Pagamento — ${quickReceiptData.inquilino}`}
            </h3>

            {quickReceiptData.isCaucaoAjuste ? (
              <div className="space-y-4 text-xs">
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label className="font-bold block mb-1">Reduções Extra (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={quickReceiptData.reducoesExtra ?? ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, reducoesExtra: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800 font-semibold"
                    />
                  </div>
                  <div>
                    <label className="font-bold block mb-1">Despesas Extra (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={quickReceiptData.despesasExtra ?? ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, despesasExtra: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800 font-semibold"
                    />
                  </div>
                  <div>
                    <label className="font-bold block mb-1">Taxa Limpeza (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={quickReceiptData.taxaLimpeza ?? ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, taxaLimpeza: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800 font-semibold"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-bold block mb-1 text-indigo-955">Nota de Crédito (NC)</label>
                    <input
                      type="text"
                      placeholder="Ex: NC 2026/14"
                      value={quickReceiptData.refNotaCredito || ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, refNotaCredito: e.target.value })}
                      className="w-full border p-2 rounded-xl font-bold bg-indigo-50/50 text-slate-800"
                    />
                  </div>
                  <div>
                    <label className="font-bold block mb-1">Estado da Devolução</label>
                    <select
                      value={quickReceiptData.statusCaucao || "Em Processo"}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, statusCaucao: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800 font-semibold"
                    >
                      <option value="Em Processo">Em Processo</option>
                      <option value="Devolvida">Devolvida (Concluído)</option>
                    </select>
                  </div>
                </div>
                <div className="bg-indigo-50/60 p-3 rounded-xl border border-indigo-100 flex items-center justify-between text-[11px]">
                  <span className="text-indigo-955 font-medium">🏠 Apartamento: <strong className="font-black">{quickReceiptData.propriedade}</strong></span>
                  <span className="text-emerald-700 font-bold bg-emerald-50 px-2 py-0.5 rounded-lg border border-emerald-100 text-[10px]">🔗 Link Automático Vinculado</span>
                </div>
                <div>
                  <label className="font-bold block mb-1 text-slate-600 flex items-center gap-1">⏮️ Histórico de Estadias Anteriores</label>
                  <textarea
                    rows={2}
                    value={quickReceiptData.estadiasAnteriores || ""}
                    onChange={(e) => setQuickReceiptData({ ...quickReceiptData, estadiasAnteriores: e.target.value })}
                    placeholder="Ex: Principe Real 6# • Quarto 6..."
                    className="w-full border p-2.5 rounded-xl text-slate-800 focus:outline-none font-medium bg-amber-50/20 border-slate-200"
                  />
                </div>

                {quickReceiptData.mostrarEmailTemplate && (
                  <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-3 animate-fadeIn">
                    <div className="flex justify-between items-center border-b pb-2">
                      <span className="font-black text-indigo-900 uppercase text-[10px]">Email Pronto</span>
                      <button
                        type="button"
                        onClick={() => {
                          const cInicial = parseFloat(quickReceiptData.caucao) || 0;
                          const rExtra = parseFloat(quickReceiptData.reducoesExtra) || 0;
                          const dExtra = parseFloat(quickReceiptData.despesasExtra) || 0;
                          const tLimpeza = parseFloat(quickReceiptData.taxaLimpeza) || 0;
                          const vLiquido = Math.max(0, cInicial - (rExtra + dExtra + tLimpeza));
                          const urlFicheiro = LINKS_DESPESAS_PROPRIEDADES[quickReceiptData.propriedade] || "https://coolivin.com";
                          const emailTexto = `Hey, 😃\nHope you're doing great!\n\n⚠️ PLEASE READ THIS MESSAGE CAREFULLY.\n\nWe hope that you had a great stay with us!\n\nWe are sending you this email in order to proceed with the reimbursement of the deposit you paid at the beginning of your stay. As you were aware, the bills covered were 35€ per person and per month.\n\nThe extra bills per month are split between all the tenants that were staying in the apartment and deducted from everyone's deposit. If you want to take a look at the details of each month’s bills, you can find it at this link:\n👉 ${urlFicheiro}\n\nThe check-out cleaning fee is also deducted from your deposit and you can find this information on your contract.\n\nHere is the breakdown of your deposit deductions:\n\n🔹 DEPOSIT PAID: ${cInicial.toFixed(2)}€\n🔹 EXTRA DEDUCTIONS: ${rExtra.toFixed(2)}€\n🔹 EXTRA BILLS: ${dExtra.toFixed(2)}€\n🔹 FINAL CLEANING FEE: ${tLimpeza.toFixed(2)}€\n\n💰 DEPOSIT TO BE REIMBURSED: ${vLiquido.toFixed(2)}€\n\nIn light of this, we would like to ask you about which IBAN you would prefer the deposit to be sent to. Please send us these details as soon as possible so we can move forward.\n\nBest regards,\nCoolivin Team\n\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\nOlá, 😃\nEsperamos que estejas bem!\n\n⚠️ POR FAVOR LÊ ESTA MENSAGEM COM ATENÇÃO.\n\nEsperamos que tenhas tido uma ótima estadia connosco!\n\nEstamos a enviar-te este e-mail para te reembolsar o depósito que pagaste no início da tua estadia. Como sabes, as contas cobertas eram de 35€ por pessoa e por mês.\n\nAs contas extras por mês são divididas entre todos os inquilinos que estavam hospedados no apartamento e deduzidas do depósito de todos. Se quiseres verificar os detalhes das contas de cada mês, podes encontrar o link do ficheiro com todas essa informações aqui:\n👉 ${urlFicheiro}\n\nA taxa de limpeza do check-out também é deduzida do teu depósito e podes encontrar essa informação no teu contrato.\n\nAqui fica o resumo detalhado dos valores do teu depósito:\n\n🔹 DEPÓSITO PAGO: ${cInicial.toFixed(2)}€\n🔹 DEDUÇÕES EXTRA: ${rExtra.toFixed(2)}€\n🔹 DESPESAS EXTRA: ${dExtra.toFixed(2)}€\n🔹 TAXA DE LIMPEZA FINAL: ${tLimpeza.toFixed(2)}€\n\n💰 DEPÓSITO A SER REEMBOLSADO: ${vLiquido.toFixed(2)}€\n\nCom isto, gostaríamos de te perguntar para qual IBAN preferes que o teu depósito seja enviado. Por favor, envia-nos estes detalhes o mais rapidamente possível para podermos avançar.\n\nCom os melhores cumprimentos,\nEquipa Coolivin`;
                          navigator.clipboard.writeText(emailTexto);
                          alert("E-mail com link automático copiado! 📋🚀");
                        }}
                        className="bg-indigo-600 text-white px-2 py-1 rounded font-bold text-[10px]"
                      >
                        📋 Copiar Texto Completo
                      </button>
                    </div>
                    <div className="max-h-32 overflow-y-auto font-mono text-[10px] text-slate-600 bg-white p-3 rounded-xl border leading-relaxed whitespace-pre-wrap">
                      {`🔹 DEPOSIT PAID: ${(parseFloat(quickReceiptData.caucao) || 0).toFixed(2)}€\n💰 DEPOSIT TO BE REIMBURSED: ${Math.max(0, (parseFloat(quickReceiptData.caucao) || 0) - ((parseFloat(quickReceiptData.reducoesExtra) || 0) + (parseFloat(quickReceiptData.despesasExtra) || 0) + (parseFloat(quickReceiptData.taxaLimpeza) || 0))).toFixed(2)}€`}
                    </div>
                  </div>
                )}
                <div className="flex flex-wrap gap-2 pt-2">
                  <button type="button" onClick={() => setQuickReceiptData({ ...quickReceiptData, mostrarEmailTemplate: !quickReceiptData.mostrarEmailTemplate })} className="flex-1 bg-amber-500 text-white font-bold py-2.5 rounded-xl border border-amber-600">
                    {quickReceiptData.mostrarEmailTemplate ? "Esconder Template" : "✉️ Gerar Email"}
                  </button>
                  <button type="button" onClick={async () => {
                    const updatedStay = {
                      ...quickReceiptData,
                      reducoesExtra: parseFloat(quickReceiptData.reducoesExtra) || 0,
                      despesasExtra: parseFloat(quickReceiptData.despesasExtra) || 0,
                      taxaLimpeza: parseFloat(quickReceiptData.taxaLimpeza) || 0,
                      refNotaCredito: quickReceiptData.refNotaCredito || "",
                      statusCaucao: quickReceiptData.statusCaucao || "Em Processo",
                      estadiasAnteriores: quickReceiptData.estadiasAnteriores || "",
                    };
                    setStays((prev) => prev.map((s) => s.id === updatedStay.id ? updatedStay : s));
                    await persistDoc("stays", updatedStay.id, updatedStay);
                    setQuickReceiptData(null);
                    setSyncMessage({ type: "success", text: "Alterações guardadas com sucesso!" });
                  }} className="flex-1 bg-slate-100 text-slate-700 font-bold py-2.5 rounded-xl border">Guardar Dados</button>
                  <button type="button" onClick={async () => {
                    const updatedStay = {
                      ...quickReceiptData,
                      reducoesExtra: parseFloat(quickReceiptData.reducoesExtra) || 0,
                      despesasExtra: parseFloat(quickReceiptData.despesasExtra) || 0,
                      taxaLimpeza: parseFloat(quickReceiptData.taxaLimpeza) || 0,
                      refNotaCredito: quickReceiptData.refNotaCredito || "",
                      statusCaucao: "Devolvida",
                      estadiasAnteriores: quickReceiptData.estadiasAnteriores || "",
                    };
                    setStays((prev) => prev.map((s) => s.id === updatedStay.id ? updatedStay : s));
                    await persistDoc("stays", updatedStay.id, updatedStay);
                    setQuickReceiptData(null);
                    setSyncMessage({ type: "success", text: "Reembolso finalizado com sucesso!" });
                  }} className="flex-1 bg-slate-955 text-white font-bold py-2.5 rounded-xl shadow">Confirmar Reembolso</button>
                  <button type="button" onClick={() => setQuickReceiptData(null)} className="bg-white border px-4 py-2.5 rounded-xl font-bold text-slate-500">Cancelar</button>
                </div>
              </div>
            ) : (
              <form onSubmit={handleTranchePayConfirm} className="space-y-4 text-xs">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-bold block mb-1 text-indigo-955">Valor Devido (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={quickReceiptData.valorDevido || 0}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, valorDevido: parseFloat(e.target.value) || 0 })}
                      className="w-full border p-2 rounded-xl font-bold bg-indigo-50/50 border-indigo-100 text-slate-800"
                      required
                    />
                  </div>
                  <div>
                    <label className="font-bold block mb-1">Valor Recebido (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={quickReceiptData.valorRecebido || ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, valorRecebido: e.target.value })}
                      className="w-full border p-2 rounded-xl font-bold text-slate-800"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-bold block mb-1">Ref. Fatura</label>
                    <input
                      type="text"
                      placeholder="Ex: FT 2026894"
                      value={quickReceiptData.refFatura || ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, refFatura: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800"
                    />
                  </div>
                  <div>
                    <label className="font-bold block mb-1">Data Liquidação</label>
                    <input
                      type="date"
                      value={quickReceiptData.dataRecebimento || ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, dataRecebimento: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="font-bold block mb-1">Método</label>
                    <select
                      value={quickReceiptData.metodo || "Transferência"}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, metodo: e.target.value })}
                      className="w-full border p-2 rounded-xl text-slate-800 font-semibold"
                    >
                      <option value="Transferência">Transferência</option>
                      <option value="Revolut/MBWay">Revolut/MBWay</option>
                      <option value="Stripe">Stripe</option>
                    </select>
                  </div>
                  <div>
                    <label className="font-bold block mb-1 text-indigo-955">Mês de Cobrança / Vencimento</label>
                    <select
                      value={quickReceiptData.mesVencimento || ""}
                      onChange={(e) => setQuickReceiptData({ ...quickReceiptData, mesVencimento: e.target.value })}
                      className="w-full border p-2 rounded-xl font-bold bg-indigo-50/50 border-indigo-100 text-slate-800"
                    >
                      <option value="2026-01">Janeiro 2026</option>
                      <option value="2026-02">Fevereiro 2026</option>
                      <option value="2026-03">Março 2026</option>
                      <option value="2026-04">Abril 2026</option>
                      <option value="2026-05">Maio 2026</option>
                      <option value="2026-06">Junho 2026</option>
                      <option value="2026-07">Julho 2026</option>
                      <option value="2026-08">Agosto 2026</option>
                      <option value="2026-09">Setembro 2026</option>
                      <option value="2026-10">Outubro 2026</option>
                      <option value="2026-11">Novembro 2026</option>
                      <option value="2026-12">Dezembro 2026</option>
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="font-bold block mb-1">Notas da Tranche</label>
                  <textarea
                    rows={2}
                    value={quickReceiptData.notas || ""}
                    onChange={(e) => setQuickReceiptData({ ...quickReceiptData, notas: e.target.value })}
                    className="w-full border p-2 rounded-xl text-slate-855 focus:outline-none"
                    placeholder="Adiciona notas..."
                  />
                </div>
                <div className="flex flex-wrap gap-2 pt-2">
                  <button type="submit" onClick={() => { quickReceiptData.recalculasTranches = true; }} className="flex-1 bg-slate-955 hover:bg-slate-900 text-white font-bold py-2.5 rounded-xl shadow text-center">Salvar e Recalcular Tranches</button>
                  <button type="submit" onClick={() => { quickReceiptData.recalculasTranches = false; }} className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-2.5 rounded-xl border text-center">Salvar Apenas Dados</button>
                  <button type="button" onClick={() => setQuickReceiptData(null)} className="bg-white border px-4 py-2.5 rounded-xl font-bold text-slate-500">Cancelar</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {editingId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white rounded-3xl max-w-2xl w-full p-6 shadow-2xl max-h-[92vh] overflow-y-auto">
            <div className="flex justify-between items-start border-b pb-3">
              <h3 className="text-base font-black text-slate-955">Editar Contrato: {editFormData.inquilino}</h3>
              <button type="button" onClick={() => setEditingId(null)} className="text-slate-400 bg-slate-100 hover:bg-slate-200 transition-colors w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold">✕</button>
            </div>
            <div className="space-y-6 mt-5 text-xs">
              <div className="space-y-3">
                <h4 className="text-[10px] font-black uppercase text-indigo-900 border-b pb-1">1. Morada, Reserva & Configuração do Contrato</h4>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Apartamento *</label>
                    <select value={editFormData.propriedade || ""} onChange={(e) => setEditFormData({ ...editFormData, propriedade: e.target.value })} className="w-full bg-slate-50 border p-2 rounded-xl text-slate-800">
                      {PROPRIEDADES.map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Quarto / ID *</label>
                    <input type="text" value={editFormData.quarto || ""} onChange={(e) => setEditFormData({ ...editFormData, quarto: e.target.value })} className="w-full bg-slate-50 border p-2 rounded-xl text-slate-800" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Data Reserva *</label>
                    <input type="date" value={editFormData.dataReserva || ""} onChange={(e) => setEditFormData({ ...editFormData, dataReserva: e.target.value })} className="w-full bg-slate-50 border p-2 rounded-xl text-slate-800" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Estado *</label>
                    <select value={editFormData.status || "Ativo"} onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })} className="w-full bg-slate-50 border p-2 rounded-xl text-slate-800">
                      <option value="Ativo">Ativo</option>
                      <option value="Reservado">Reservado</option>
                      <option value="Concluído">Concluído</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Início *</label>
                    <input type="date" value={editFormData.checkIn || ""} onChange={(e) => setEditFormData({ ...editFormData, checkIn: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Fim *</label>
                    <input type="date" value={editFormData.checkOut || ""} onChange={(e) => setEditFormData({ ...editFormData, checkOut: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Renda Base (€) *</label>
                    <input type="number" value={editFormData.renda || ""} onChange={(e) => setEditFormData({ ...editFormData, renda: e.target.value })} className="w-full bg-slate-50 border p-2 font-bold" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Caução (€)</label>
                    <input type="number" value={editFormData.caucao || ""} onChange={(e) => setEditFormData({ ...editFormData, caucao: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Admin Fee (€)</label>
                    <input type="number" value={editFormData.adminFee || ""} onChange={(e) => setEditFormData({ ...editFormData, adminFee: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                  <div>
                    <label className="block text-indigo-955 font-bold mb-1">Desp. Comuns (€) *</label>
                    <input type="number" value={editFormData.despesasComuns || ""} onChange={(e) => setEditFormData({ ...editFormData, despesasComuns: e.target.value })} className="w-full bg-indigo-50 border border-indigo-200 p-2 font-bold shadow-sm" required />
                  </div>
                </div>
              </div>

              <div className="space-y-3 border-t pt-4">
                <h4 className="text-[10px] font-black uppercase text-indigo-900 border-b pb-1">2. Dados do Inquilino</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Nome Completo *</label>
                    <input type="text" value={editFormData.inquilino || ""} onChange={(e) => setEditFormData({ ...editFormData, inquilino: e.target.value })} className="w-full bg-slate-50 border p-2 font-semibold" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Email *</label>
                    <input type="email" value={editFormData.email || ""} onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Telemóvel *</label>
                    <input type="text" value={editFormData.telemovel || ""} onChange={(e) => setEditFormData({ ...editFormData, telemovel: e.target.value })} className="w-full bg-slate-50 border p-2" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Ocupação *</label>
                    <select value={editFormData.ocupacao || "Trabalhador"} onChange={(e) => setEditFormData({ ...editFormData, ocupacao: e.target.value })} className="w-full bg-slate-50 border p-2">
                      <option value="Trabalhador">Trabalhador</option>
                      <option value="Estudante">Estudante</option>
                    </select>
                  </div>
                  {editFormData.ocupacao === "Estudante" && (
                    <div className="animate-fadeIn">
                      <label className="block text-indigo-955 font-bold mb-1">Universidade *</label>
                      <input type="text" value={editFormData.universidade || ""} onChange={(e) => setEditFormData({ ...editFormData, universidade: e.target.value })} className="w-full bg-indigo-50 border p-2" required />
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-3 border-t pt-4">
                <h4 className="text-[10px] font-black uppercase text-indigo-900 border-b pb-1">3. Origem & Comissões</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-slate-500 font-bold mb-1">Fechou pela Coolivin? *</label>
                    <select value={editFormData.origemCoolivin || "Sim"} onChange={(e) => setEditFormData({ ...editFormData, origemCoolivin: e.target.value })} className="w-full bg-slate-50 border p-2">
                      <option value="Sim">Sim (Direto)</option>
                      <option value="Não">Não (Canais Externos)</option>
                    </select>
                  </div>
                  {editFormData.origemCoolivin === "Não" && (
                    <>
                      <div>
                        <label className="block text-indigo-955 font-bold mb-1">Plataforma *</label>
                        <input type="text" placeholder="Uniplaces" value={editFormData.plataformaOrigem || ""} onChange={(e) => setEditFormData({ ...editFormData, plataformaOrigem: e.target.value })} className="w-full bg-indigo-50 border p-2" required />
                      </div>
                      <div>
                        <label className="block text-indigo-955 font-bold mb-1">Comissão (€) *</label>
                        <input type="number" placeholder="319.80" value={editFormData.comissaoValor || ""} onChange={(e) => setEditFormData({ ...editFormData, comissaoValor: e.target.value })} className="w-full bg-indigo-50 border p-2 font-bold" required />
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="pt-4 border-t flex gap-3 bg-slate-50">
                <button onClick={() => saveEdit(editFormData.id)} className="flex-1 bg-slate-950 text-white font-bold py-3.5 rounded-xl text-xs uppercase tracking-wider shadow-sm">SALVAR ALTERAÇÕES</button>
                <button type="button" onClick={() => setEditingId(null)} className="flex-1 bg-slate-100 text-slate-700 font-bold py-3.5 rounded-xl text-xs hover:bg-slate-200 transition-all">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
